import React, { Component } from 'react';
import Radio from '@mui/material/Radio';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import Button from 'app/common/button';

class SurveyDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: '',
      comment: '',
      leasedByAB: '',
      open: this.props.open
    };
  }

  handleChange = (event) => {
    const {
      target: { name, value }
    } = event;
    if (name === 'rating') {
      this.setState({ [name]: parseInt(value) });
      return;
    }
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { open: _, ...feedback } = this.state;
    this.handleClose();
    this.props.onSubmit(feedback);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { rating, open, leasedByAB } = this.state;
    return (
      <Dialog open={open}>
        <DialogTitle>Spørgeskema</DialogTitle>
        <DialogContent>
          <div style={{ marginBottom: '16px' }}>
            <label>Har du fået udlejet din bolig gennem Akutbolig.dk?</label>
            <RadioGroup
              aria-label="Rating"
              name="leasedByAB"
              value={leasedByAB}
              row
              onChange={this.handleChange}
            >
              <FormControlLabel
                value="YES"
                control={<Radio color="primary" />}
                label="Ja"
              />
              <FormControlLabel
                value="NO"
                control={<Radio color="primary" />}
                label="Nej"
              />
              <FormControlLabel
                value="DONT_KNOW"
                control={<Radio color="primary" />}
                label="Ved ikke"
              />
            </RadioGroup>
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label>Hvor tilfreds er du med vores service?</label>
            <br />
            <small>(1: Ikke tilfreds - 5: Meget tilfreds)</small>
            <RadioGroup
              aria-label="Rating"
              name="rating"
              value={String(rating)}
              row
              onChange={this.handleChange}
            >
              <FormControlLabel
                value="1"
                control={<Radio color="primary" />}
                label="1"
              />
              <FormControlLabel
                value="2"
                control={<Radio color="primary" />}
                label="2"
              />
              <FormControlLabel
                value="3"
                control={<Radio color="primary" />}
                label="3"
              />
              <FormControlLabel
                value="4"
                control={<Radio color="primary" />}
                label="4"
              />
              <FormControlLabel
                value="5"
                control={<Radio color="primary" />}
                label="5"
              />
            </RadioGroup>
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label>Dit feedback til os:</label>
            <TextField
              onChange={this.handleChange}
              name="comment"
              multiline
              fullWidth
              helperText="Lad os endelige vide, hvad vi har gjort godt og hvad vi kan gøre bedre."
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            label="Deaktivér lejemålet"
            primary
            icon="done"
            onClick={this.handleSubmit}
            style={{ marginLeft: '0.5em' }}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default SurveyDialog;